import React from 'react';
import { useInfluencerStore } from '@/stores/influencerStore';

export const ReferralStats: React.FC = () => {
  const { dashboardData } = useInfluencerStore();

  if (!dashboardData) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No referral stats available</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-medium mb-4">Referral Statistics</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600">
              {dashboardData.personalStats.totalClicks}
            </div>
            <div className="text-sm text-gray-500">Total Clicks</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-green-600">
              {dashboardData.personalStats.totalSignups}
            </div>
            <div className="text-sm text-gray-500">Total Signups</div>
          </div>
        </div>
      </div>
    </div>
  );
}; 